module.exports = __webpack_public_path__ + "img/questionnaire_device_ar.d07dc75b.png";